import queryString from "query-string";

import { createApiPdf } from "@/apiv2/common";

import { createApi } from "./common";

export const getDrawingItem = (token, { customerUid, orderUid, itemUid }) =>
  createApi("GET", `customers/${customerUid}/orders/${orderUid}/items/${itemUid}/drawings/`)(token);

export const getDrawingsOrder = (token, { customerUid, orderUid, params = {} }) => {
  const queryParams = queryString.stringify(params);
  return createApi(
    "GET",
    `customers/${customerUid}/orders/${orderUid}/drawings/?${queryParams}`
  )(token);
};

export const putOrderDrawingSvg = (token, data) =>
  createApiPdf("PUT", "order/drawings_svg/", {
    responseType: "arraybuffer",
    Accept: "/application/pdf",
    headers: { "Content-Type": "multipart/form-data" },
  })(token, data);

export default getDrawingItem;
